// appsActions.js
import {
  ADD_CUSTOM_COLLECTION,
  REMOVE_CUSTOM_COLLECTION,
  INIT_CUSTOM_COLLECTION
} from './../types/collectionConstants'

export function initCustomCollections(items) {
  return {
    type: INIT_CUSTOM_COLLECTION,
    payload: items
  }
}

export function addCustomCollection(item) {
  return {
    type: ADD_CUSTOM_COLLECTION,
    payload: item
  }
}

export function removeCustomCollection(item) {
  return {
    type: REMOVE_CUSTOM_COLLECTION,
    payload: item
  }
}
